import Dependency from "../../../model2/dependency/dependency"
import ModelEntity from "../../../model2/model-entity"
import Resources from "../../../resources/resources"
import {DependencyType} from "../../../model2/dependency/const"
import {EntityType} from "../../../gd/const/item"

// Shape ModalDependencyInfo renders. `id` is the RID ("t-xxx") - onRemove consumers are handed
// those ids and split them back on the prefix, so it must not be the plain entity id.
export type DependencyInfoSide = {
    type    : EntityType
    id      : RID
    item    : ModelEntity
}

export type DependencyInfo = {
    type        : DependencyType
    predecessor : DependencyInfoSide
    successor   : DependencyInfoSide
}

const toSide = (entity: ModelEntity): DependencyInfoSide => ({
    type    : entity.entityType,
    id      : entity.rid,
    item    : entity,
})

/**
 * Builds the dependency info for the modal out of the two entities it links.
 *
 * Gantt views fill task.predecessors / task.successors from resources (see
 * resources_initSuccessorsPredecessors), so those entries are the plain task/project/event models
 * and carry no dependencyId - the dependency record itself has to be looked up by the RID pair.
 *
 * Returns null when the dependency is not in resources, so callers can fall back to loading it.
 */
export default function getDependencyInfo(resources     : Resources | undefined | null,
                                          predecessor   : ModelEntity | undefined,
                                          successor     : ModelEntity | undefined): DependencyInfo | null {

    if (!predecessor || !successor) {
        return null
    }

    // Dependency normalizes START_FINISH into FINISH_START, so firstRID is always the predecessor
    const dependency = _.find(resources?.dependencies?.models, (d: Dependency) =>
        d.firstRID === predecessor.rid && d.secondRID === successor.rid) as Dependency | undefined

    if (!dependency) return null

    return {
        type        : dependency.type,
        predecessor : toSide(predecessor),
        successor   : toSide(successor),
    }
}
